import {Avatar} from '../avatar/avatar';
import {colors} from '../colors/colors';

type Props = {
    size: number;
    type?: string;
    isOnline?: boolean | null | undefined;
};

export function UnidentifiedChatAvatar(props: Props) {
    return (
        <Avatar
            size={props.size}
            type={'unidentifiedChat'}
            avatarUrl={null}
            color={colors.grey}
            isOnline={props.isOnline}
        />
    );
}
